import React, { useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Play } from 'lucide-react';

export const HeroSection = () => {
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen w-full overflow-hidden bg-black">
      {/* Company Video Background */}
      <div className="absolute inset-0 w-full h-full">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        >
          {/* Your Company Showreel Video */}
          <source src="https://customer-assets-cm19k8pv.emergentagent.net/job_lalit-precision/artifacts/f3bf056b15289454_Lalit%20Interior%20.mp4" type="video/mp4" />
        </video>
        
        {/* Lighter Overlay for Better Video Visibility */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/40"></div>
        
        {/* Subtle Vignette */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,transparent_50%,rgba(0,0,0,0.3)_100%)]"></div>
        
        {/* Orange Accent Glow - Very Subtle */}
        <div className="absolute inset-0">
          <div className="absolute top-1/3 right-0 w-96 h-96 bg-[#FF6B00] rounded-full blur-[150px] opacity-5"></div>
          <div className="absolute bottom-1/4 left-0 w-80 h-80 bg-[#FF6B00] rounded-full blur-[120px] opacity-5"></div>
        </div>
      </div>

      {/* Main Content */}
      <div className="relative min-h-screen flex items-end justify-center px-6 md:px-12 lg:px-20 z-10 pb-24">
        <div className="max-w-7xl w-full">
          {/* Stats Row - Positioned at Bottom */}
          <div className="grid grid-cols-3 gap-6 max-w-4xl mx-auto mb-12 animate-fade-in-up">
            <div className="group p-8 bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 hover:border-[#FF6B00]/50 transition-all duration-500 hover:scale-105">
              <div className="text-5xl font-black bg-gradient-to-r from-[#FF6B00] to-[#FFB366] bg-clip-text text-transparent mb-2">8+</div>
              <div className="text-white text-sm font-medium uppercase tracking-wider">Years Excellence</div>
            </div>
            <div className="group p-8 bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 hover:border-[#FF6B00]/50 transition-all duration-500 hover:scale-105">
              <div className="text-5xl font-black bg-gradient-to-r from-[#FF6B00] to-[#FFB366] bg-clip-text text-transparent mb-2">2L+</div>
              <div className="text-white text-sm font-medium uppercase tracking-wider">Sq.Ft Delivered</div>
            </div>
            <div className="group p-8 bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 hover:border-[#FF6B00]/50 transition-all duration-500 hover:scale-105">
              <div className="text-5xl font-black bg-gradient-to-r from-[#FF6B00] to-[#FFB366] bg-clip-text text-transparent mb-2">150+</div>
              <div className="text-white text-sm font-medium uppercase tracking-wider">Projects Complete</div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center animate-fade-in-up animation-delay-300">
            <Button
              onClick={scrollToServices}
              className="group relative px-10 py-7 bg-gradient-to-r from-[#FF6B00] to-[#E65F00] text-white text-lg font-bold rounded-full overflow-hidden transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-[#FF6B00]/50"
            >
              <span className="relative z-10 flex items-center gap-3">
                Explore Our Work
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-[#E65F00] to-[#FF6B00] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </Button>
            
            <Button
              onClick={scrollToContact}
              className="group relative px-10 py-7 bg-white/10 backdrop-blur-md text-white text-lg font-bold rounded-full border-2 border-white/30 hover:border-[#FF6B00] overflow-hidden transition-all duration-500 hover:scale-105"
            >
              <span className="relative z-10 flex items-center gap-3">
                <Play className="w-5 h-5" />
                Start Your Project
              </span>
              <div className="absolute inset-0 bg-[#FF6B00] opacity-0 group-hover:opacity-20 transition-opacity duration-500"></div>
            </Button>
          </div>
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-white via-white/50 to-transparent z-10"></div>
      
      {/* Decorative Lines */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#FF6B00] to-transparent z-10"></div>
    </section>
  );
};
